import * as React from 'react';
import { sortBasedOnList } from '../utils';

export type Table9b1Data = { [key: string]: Table9b1Row }
export type Table9b1Row = {
  pedestrianKilledTotal: number;
  pedestrianKilledM: number;
  pedestrianKilledF: number;
  pedestrianKilledU: number;
  pedestrianInjuredTotalM: number;
  pedestrianInjuredTotalF: number;
  pedestrianInjuredTotalU: number;
  pedestrianInjuredAM: number;
  pedestrianInjuredAF: number;
  pedestrianInjuredAU: number;
  pedestrianInjuredBM: number;
  pedestrianInjuredBF: number;
  pedestrianInjuredBU: number;
  pedestrianInjuredCM: number;
  pedestrianInjuredCF: number;
  pedestrianInjuredCU: number;
  cyclistKilledTotal: number;
  cyclistKilledM: number;
  cyclistKilledF: number;
  cyclistKilledU: number;
  cyclistInjuredTotalM: number;
  cyclistInjuredTotalF: number;
  cyclistInjuredTotalU: number;
  cyclistInjuredAM: number;
  cyclistInjuredAF: number;
  cyclistInjuredAU: number;
  cyclistInjuredBM: number;
  cyclistInjuredBF: number;
  cyclistInjuredBU: number;
  cyclistInjuredCM: number;
  cyclistInjuredCF: number;
  cyclistInjuredCU: number;
}
export interface ITable9b2Props {
  data: Table9b1Data;
}

const sortOrder = [
  "14 and younger",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
  "21",
  "22",
  "23",
  "24",
  "25-34",
  "35-44",
  "45-54",
  "55-64",
  "65-74",
  "75 and older",
  "Age not stated",
  "TOTALS",
];

export default class Table9b1 extends React.Component<ITable9b2Props> {

  public render() {
    return (
      <React.Fragment>
        {!this.props.data && (
          <p>Loading....</p>
        )}
        {this.props.data && (
          <table className="ss-table summaryTable1">
            <colgroup>
              <col style={{ width: '20%' }} />
            </colgroup>
            <thead>
              <tr>
                <th rowSpan={4} className="border-right-bold">
                  <div className="ss-table-header">
                    <span className="header-number" style={{ border: 'none' }}>9b1</span>
                    <div style={{ width: '3px', height: '80px', borderLeft: '3px solid black' }} />
                    <span className="header-text">AGE AND SEX OF CASUALTIES</span>
                  </div>
                </th>
                <th colSpan={13} className="border-right-bold">PEDESTRIANS</th>
                <th colSpan={13}>CYCLISTS</th>
              </tr>
              <tr>
                <th rowSpan={2} colSpan={4} className="border-right-bold">KILLED</th>
                <th colSpan={9} className="border-right-bold">INJURED</th>
                <th rowSpan={2} colSpan={4} className="border-right-bold">KILLED</th>
                <th colSpan={9}>INJURED</th>
              </tr>
              <tr>
                <th colSpan={3} className="border-right-bold">A *</th>
                <th colSpan={3} className="border-right-bold">B * </th>
                <th colSpan={3} className="border-right-bold">C * </th>
                <th colSpan={3} className="border-right-bold">A *</th>
                <th colSpan={3} className="border-right-bold">B * </th>
                <th colSpan={3}>C * </th>
              </tr>
              <tr>
                <th>Total</th>
                <th>M</th>
                <th>F</th>
                <th className="border-right-bold">U</th>

                <th>M</th>
                <th>F</th>
                <th className="border-right-bold">U</th>

                <th>M</th>
                <th>F</th>
                <th className="border-right-bold">U</th>

                <th>M</th>
                <th>F</th>
                <th className="border-right-bold">U</th>
                <th>Total</th>
                <th>M</th>
                <th>F</th>
                <th className="border-right-bold">U</th>

                <th>M</th>
                <th>F</th>
                <th className="border-right-bold">U</th>

                <th>M</th>
                <th>F</th>
                <th className="border-right-bold">U</th>

                <th>M</th>
                <th>F</th>
                <th>U</th>
              </tr>
            </thead>
            <tbody>
              {sortBasedOnList(this.props.data, sortOrder).map((key) =>
                <tr key={key} className={key === "TOTALS" ? "border-bold bold-text" : null}>
                  <td className="border-right-bold">{key}</td>
                  <td className="numberTotals">{this.props.data[key].pedestrianKilledTotal}</td>
                  <td className="numberTotals">{this.props.data[key].pedestrianKilledM}</td>
                  <td className="numberTotals">{this.props.data[key].pedestrianKilledF}</td>
                  <td className="numberTotals border-right-bold">{this.props.data[key].pedestrianKilledU}</td>
                  <td className="numberTotals">{this.props.data[key].pedestrianInjuredAM}</td>
                  <td className="numberTotals">{this.props.data[key].pedestrianInjuredAF}</td>
                  <td className="numberTotals border-right-bold">{this.props.data[key].pedestrianInjuredAU}</td>
                  <td className="numberTotals">{this.props.data[key].pedestrianInjuredBM}</td>
                  <td className="numberTotals">{this.props.data[key].pedestrianInjuredBF}</td>
                  <td className="numberTotals border-right-bold">{this.props.data[key].pedestrianInjuredBU}</td>
                  <td className="numberTotals">{this.props.data[key].pedestrianInjuredCM}</td>
                  <td className="numberTotals">{this.props.data[key].pedestrianInjuredCF}</td>
                  <td className="numberTotals border-right-bold">{this.props.data[key].pedestrianInjuredCU}</td>
                  <td className="numberTotals">{this.props.data[key].cyclistKilledTotal}</td>
                  <td className="numberTotals">{this.props.data[key].cyclistKilledM}</td>
                  <td className="numberTotals">{this.props.data[key].cyclistKilledF}</td>
                  <td className="numberTotals border-right-bold">{this.props.data[key].cyclistKilledU}</td>
                  <td className="numberTotals">{this.props.data[key].cyclistInjuredAM}</td>
                  <td className="numberTotals">{this.props.data[key].cyclistInjuredAF}</td>
                  <td className="numberTotals border-right-bold">{this.props.data[key].cyclistInjuredAU}</td>
                  <td className="numberTotals">{this.props.data[key].cyclistInjuredBM}</td>
                  <td className="numberTotals">{this.props.data[key].cyclistInjuredBF}</td>
                  <td className="numberTotals border-right-bold">{this.props.data[key].cyclistInjuredBU}</td>
                  <td className="numberTotals">{this.props.data[key].cyclistInjuredCM}</td>
                  <td className="numberTotals">{this.props.data[key].cyclistInjuredCF}</td>
                  <td className="numberTotals">{this.props.data[key].cyclistInjuredCU}</td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </React.Fragment>
    );
  }
}
